import { Box, Flex } from '@cmpsr/components';
import { FC } from 'react';
import { IDontKnowButton } from './components/IDontKnowButton';
import {
  DateComp,
  DateProps,
  Email,
  EmailAndName,
  EmailAndNameProps,
  EmailProps,
  FreetextComp,
  FreetextProps,
  Height,
  HeightProps,
  MultipleChoice,
  MultipleChoiceProps,
  Numeric,
  NumericProps,
  Result,
  ResultProps,
  SingleChoice,
  SingleChoiceProps,
  Summary,
  SummaryProps,
  Weight,
  WeightProps,
} from './questionTypes';
import { QuestionTypeProps, type QuestionProps } from './types';

const questionTypesMap = {
  height: (props: QuestionTypeProps) => <Height {...(props as HeightProps)} />,
  weight: (props: QuestionTypeProps) => <Weight {...(props as WeightProps)} />,
  singleChoice: (props: QuestionTypeProps) => <SingleChoice {...(props as SingleChoiceProps)} />,
  multipleChoice: (props: QuestionTypeProps) => <MultipleChoice {...(props as MultipleChoiceProps)} />,
  number: (props: QuestionTypeProps) => <Numeric {...(props as NumericProps)} />,
  date: (props: QuestionTypeProps) => <DateComp {...(props as DateProps)} />,
  email: (props: QuestionTypeProps) => <Email {...(props as EmailProps)} />,
  summary: (props: QuestionTypeProps) => <Summary {...(props as unknown as SummaryProps)} />,
  result: (props: QuestionTypeProps) => <Result {...(props as unknown as ResultProps)} />,
  freetext: (props: QuestionTypeProps) => <FreetextComp {...(props as unknown as FreetextProps)} />,
  emailAndName: (props: QuestionTypeProps) => <EmailAndName {...(props as unknown as EmailAndNameProps)} />,
};

export const Question: FC<QuestionProps> = ({ submitIDKAnswer, paginationDispatch, question, ...props }) => {
  return (
    <Box flexGrow="1">
      <Flex justifyContent="center" mt={{ base: 8, lg: 16 }} mb={8} px={10}>
        {questionTypesMap[question.type]({
          ...props,
          data: question,
        } as QuestionTypeProps)}
      </Flex>
      {question.skippable && (
        <Flex justifyContent="center">
          <IDontKnowButton submitIDKAnswer={submitIDKAnswer} paginationDispatch={paginationDispatch} />
        </Flex>
      )}
    </Box>
  );
};
